import axios from '../../axios'

/*
 * 服务卡激活码数据接口
 */

// 服务卡激活码数据接口
export const getCardCodeList = (data) => {
    return axios({
        url: '/api/admin/card/code',
        method: 'post',
        data
    })
}

// 编辑激活码信息接口
export const editCodeInfo = (data) => {
    return axios({
        url: '/api/admin/card/code/update',
        method: 'post',
        data
    })
}

// 获取激活码列表
export const getSerialNo = (data) => {
    return axios({
        url: '/api/admin/card/code/serial/no',
        method: 'GET',
        data
    })
}

// 激活码重置接口
export const resetCode = (data) => {
    return axios({
        url: '/api/admin/card/code',
        method: 'put',
        data
    })
}

// 服务卡管理后台接口
export const card = (data) => {
    return axios({
        url: '/api/base/card',
        method: data.method,
        data: data.data
    })
}

// 卡片信息
export const info = (data) => {
    return axios({
        url: '/api/base/card/info',
        method: 'get',
        data
    })
}

// 激活码生成规则查询接口
export const codeRuleList = (data) => {
    return axios({
        url: '/api/admin/card/code/rule',
        method: 'GET',
        data
    })
}

// 批量生成激活码接口
export const creatCodeRule = (data) => {
    return axios({
        url: '/api/admin/card/code/rule',
        method: 'POST',
        data
    })
}

// 激活码追加接口
export const addToCode = (data) => {
    return axios({
        url: '/api/admin/card/code/rule',
        method: 'PUT',
        data
    })
}

// 激活码导出接口
export const exportCode = (data) => {
    return axios({
        url: '/api/admin/card/code/export',
        method: 'GET',
        data
    })
}

// 激活码批量更新过期时间接口
export const allCodeUpdate = (data) => {
    return axios({
        url: '/api/admin/card/code/batch/update/expire',
        method: 'POST',
        data
    })
}

// 激活码作废接口
export const clearCode = (data) => {
    return axios({
        url: '/api/admin/card/code/cancel',
        method: 'POST',
        data
    })
}

// 激活码批量更新接口
export const batchUpdateCode = (data) => {
    return axios({
        url: '/api/admin/card/code/batch/update',
        method: 'POST',
        data
    })
}

// 在线获取激活码批量创建接口
export const creatOnlineCodeRule = (data) => {
    return axios({
        url: '/api/admin/card/code/online/rule',
        method: 'POST',
        data
    })
}

// 在线获取激活码订单创建接口
export const creatOnlineCodeOrder = (data) => {
    return axios({
        url: '/api/admin/card/code/order/create',
        method: 'POST',
        data
    })
}

// 单独批量激活码订单
export const createSingleCodeOrder = (data) => {
    return axios({
        url: '/api/admin/card/code/order/create',
        method: 'POST',
        data
    })
}

// 在线获取激活码订单支付状态
export const getOnlineCodeOrderPayStatus = (data) => {
    return axios({
        url: '/api/admin/card/code/order/pay/status',
        method: 'POST',
        data
    })
}

// 分页获取激活码订单列表
export const getOnlineCodeOrderPage = (data) => {
    return axios({
        url: '/api/admin/card/code/order/list',
        method: 'POST',
        data
    })
}

// 在线获取激活码批量创建接口
export const creatSingleCodeRule = (data) => {
    return axios({
        url: '/api/admin/card/code/single/rule',
        method: 'POST',
        data
    })
}

// 获取商品列表
export const cardList = (data) => {
    return axios({
        url: '/api/base/goods',
        method: 'get',
        data
    })
}

// 添加商品
export const addCard = (data) => {
    return axios({
        url: '/api/base/goods',
        method: 'post',
        data
    })
}

// 编辑商品
export const editCard = (data) => {
    return axios({
        url: '/api/base/goods',
        method: 'put',
        data
    })
}

// 编辑商品
export const deleteCard = (data) => {
    return axios({
        url: '/api/base/goods',
        method: 'delete',
        data
    })
}

// 根据id获取商品
export const getCard = (data) => {
    return axios({
        url: '/api/base/goods/get',
        method: 'get',
        data
    })
}

// 获取优惠券列表
export const couponList = (data) => {
    return axios({
        url: '/api/base/coupon',
        method: 'get',
        data
    })
}

// 删除优惠券
export const addCoupon = (data) => {
    return axios({
        url: '/api/base/coupon',
        method: 'post',
        data
    })
}

// 编辑优惠券
export const editCoupon = (data) => {
    return axios({
        url: '/api/base/coupon',
        method: 'put',
        data
    })
}

// 查询优惠券
export const getCoupon = (data) => {
    return axios({
        url: '/api/base/coupon/get',
        method: 'get',
        data
    })
}

// 删除优惠券
export const delCoupon = (data) => {
    return axios({
        url: '/api/base/coupon',
        method: 'delete',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/code.js